export const isPresent = (...elements) => {
	return elements.every(arg => arg !== undefined && arg !== null);
};
